import styles from './button.module.scss'

export default function Button(props) {
  const { stylingClass, ...otherProps } = props
  return (
    <button type="button" className={`${styles.button} ${stylingClass}`} {...otherProps} />
  )
}
